import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.intro',
    },
    translateTreshold: 0.9,
};

class Intro {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
    }

    init() {
        $(window).on('scroll', () => {
            this._reveal();
        });
    }

    _reveal() {
        const elementTop = this._$rootElement.offset().top;
        const elementBottom = elementTop + this._$rootElement.outerHeight();
        const elementMiddle = elementTop + (elementBottom - elementTop) / 2;
        const elementHeight = elementBottom - elementTop;
    
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        const viewportMiddle = viewportTop + (viewportBottom - viewportTop) / 2;

        // number from -1 to 1      
        // 0 indicates Element viewport middle is on element middle 
        const factor = ((elementMiddle - viewportMiddle) / (elementHeight / 2)) / 2;

        // number from 0 to 1
        const positiveFactor = Math.sqrt(factor * factor)
        
        if(positiveFactor < config.translateTreshold) {
            // this._$rootElement.addClass("intro--active");
        } else {
            // intro shouldnt fly out
            // this._$rootElement.removeClass("intro--active");
        }
    }
}

moduleRegistry.registerModule('Intro', Intro);
moduleRegistry.autoApplyModule('Intro', config.selectors.root);
